module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--3@2-cb439541bf378018a03713d24cb765ca.jpg";